// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"centroDeCusto_errorMessage__2FC6X","sadDog":"centroDeCusto_sadDog__2OOsb","errorBody":"centroDeCusto_errorBody__Nwkyr"};